/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill_arrow': {
    width: 9,
    height: 6,
    viewBox: '0 0 9 6',
    data: '<path pid="0" d="M8.713.71H.682a.2.2 0 0 0-.143.339l4.01 4.127a.2.2 0 0 0 .286 0l4.02-4.127a.2.2 0 0 0-.142-.34z" _fill="#737373" fill-rule="nonzero"/>'
  }
})
